/**
 * Notification bell client (NB1, Daniel 2026-08-01).
 */
import { apiFetch } from '../auth/api';

export interface AppNotification {
  id: number;
  kind: string;
  title: string;
  body: string | null;
  link: string | null;
  entity_type: string | null;
  entity_id: number | null;
  read_at: number | null;
  created_at: number;
}

export interface NotificationFeed {
  notifications: AppNotification[];
  unread_count: number;
}

export function listNotifications(filter: 'unread' | 'read' = 'unread') {
  return apiFetch<NotificationFeed>(`/api/notifications?filter=${filter}`);
}

export function markNotificationRead(id: number) {
  return apiFetch<{ ok: true }>(`/api/notifications/${id}/read`, { method: 'POST' });
}

export function markNotificationUnread(id: number) {
  return apiFetch<{ ok: true }>(`/api/notifications/${id}/unread`, { method: 'POST' });
}

export function dismissNotification(id: number) {
  return apiFetch<{ ok: true }>(`/api/notifications/${id}`, { method: 'DELETE' });
}

export function markAllNotificationsRead() {
  return apiFetch<{ ok: true }>('/api/notifications/read-all', { method: 'POST' });
}

/** Dismisses READ rows only. Never clears something you have not seen. */
export function clearReadNotifications() {
  return apiFetch<{ ok: true; cleared: number }>('/api/notifications', { method: 'DELETE' });
}
